module.exports = __webpack_public_path__ + "static/media/noresultsfound.cf4c33d1.png";